__turbopack_context__.v({
  "ReleaseImageCardList__Container": "V37sBG_ReleaseImageCardList__Container",
  "ReleaseImageCardList__List": "V37sBG_ReleaseImageCardList__List",
});
